// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3C91V","savePackageButton":"ClientWallet_savePackageButton__3roKu"};